import clsx from 'clsx';
import React, { InputHTMLAttributes, forwardRef } from 'react';
import styles from './Input.module.css';

export const Input = forwardRef<
  HTMLInputElement,
  InputHTMLAttributes<HTMLInputElement> & {
    label?: string;
    errorMessage?: string;
  }
>(({ label, className, errorMessage, ...props }, ref) => (
  <div className={clsx(styles.inputContainer, className)}>
    {label ? (
      <label htmlFor={props.name} className={styles.label}>
        {label}
      </label>
    ) : null}
    <input
      ref={ref}
      id={props.name}
      className={clsx(
        styles.input,
        props.type === 'checkbox' && styles.inputCheckbox,
        Boolean(errorMessage) && styles.inputError,
      )}
      {...props}
    />
    {errorMessage ? (
      <p className={clsx(styles.errorMessage)}>{errorMessage}</p>
    ) : null}
  </div>
));
